import axios, {AxiosResponse} from 'axios';
import {
    Filter, FilterRetrieveResponse, HelpdeskTokenRetrieveResponse, SendPasswordResetEmailResponse, UserSendersRetrieveResponse,
    UserSponsorsRetrieveResponse
} from '@/model/CommonModel';

export default class UserApi {
    public static retrieveUserFilters(menuId: string, columnId: string): Promise<FilterRetrieveResponse> {
        return axios
            .get(`/1.0/menus/${menuId}/columns/${columnId}/filters`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static updateUserFilters(menuId: string, columnId: string, params: Filter[]): Promise<any> {
        return axios
            .put(`/1.0/menus/${menuId}/columns/${columnId}/filters`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static deleteUserAllFilters(menuId: string): Promise<any> {
        return axios
            .delete(`/1.0/menus/${menuId}/filters`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static deleteUserFilters(menuId: string, columnId: string): Promise<any> {
        return axios
            .delete(`/1.0/menus/${menuId}/columns/${columnId}/filters`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveUserSponsors(userKey: number): Promise<UserSponsorsRetrieveResponse> {
        return axios
            .get(`/1.0/users/${userKey}/sponsors`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveUserSenders(sponsorKey: string | number, userKey: string): Promise<UserSendersRetrieveResponse> {
        return axios
            .get(`/1.1/sponsors/${sponsorKey}/users/${userKey}/senders`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static sendPasswordResetEmail(userEmail: string): Promise<SendPasswordResetEmailResponse> {
        return axios
            .get(`/1.0/users/${userEmail}/password`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static getHelpdeskTokens(): Promise<HelpdeskTokenRetrieveResponse> {
        return axios.get(`/1.0/helpdesk/tokens`)
                    .then((res: AxiosResponse) => res.data);
    }
    
    public static getResetPasswordAccount(token: string): Promise<any> {
        return axios.get(`/1.0/account/reset_password/${token}`)
                    .then((res: AxiosResponse) => res.data);
    }
    
    public static saveResetPasswordAccount(userKey: string, data: any = {}): Promise<any> {
        return axios.put(`/1.0/users/${userKey}/password/email`, data)
                    .then((res: AxiosResponse) => res.data);
    }
}
